export const bgWhiteIcons = [

  { icon: ['fab', 'linkedin-in'], color: 'linkedin', bg: 'white', href: 'https://www.linkedin.com/company/guardnet-bi%CC%87li%CC%87%C5%9Fi%CC%87m-hi%CC%87zmetleri%CC%87/' } ,
  { icon: ['fab', 'youtube'], color: 'youtube', bg: 'white', href: '#!' },
  { icon: ['fab', 'instagram'], color: 'instagram', bg: 'white', href: '#!' },
];
export default [
  { icon: ['fab', 'facebook-f'], color: 'facebook', href: '#!' },
  { icon: ['fab', 'twitter'], color: 'twitter', href: '#!' },
  {
    icon: ['fab', 'google-plus-g'],
    color: 'google-plus',
    href: '#!'
  },
  { icon: ['fab', 'linkedin-in'], color: 'linkedin', href: '#!' },
  { icon: ['fab', 'medium-m'], color: 'gray-700', href: '#!' }
];
